const DUMMY_GET_DATA = "DUMMY_GET_DATA"
const DUMMY_GET_DATA_SUCCESS = "DUMMY_GET_DATA_SUCCESS"

export const getData = () => ({
  type:DUMMY_GET_DATA
})

export const getDataSuccess = (item) => ({
  type: DUMMY_GET_DATA_SUCCESS,
  payload:item
})

// export default getData